export interface TocSection {
  id: string;
  text: string;
}

/**
 * "On this page" nav for a guide's <h2> sections. Takes a static sections
 * list (id must match the matching <h2id="...">) instead of scanning the DOM
 * at runtime: the puppeteer prerenderer snapshots shortly after mount, and a
 * DOM-scan-in-an-effect version raced that snapshot and shipped an empty nav
 * in prerendered HTML even though it rendered fine for real (JS-executing)
 * visitors. A static list renders in the same pass as everything else.
 */
export function TableOfContents({ sections }: { sections: TocSection[] }) {
  if (sections.length < 3) return null;

  return (
    <nav
      aria-label="Table of contents"
      className="not-prose mb-8 rounded-lg border border-gray-200 bg-gray-50 p-4"
    >
      <p className="mb-2 text-sm font-semibold text-gray-900">On this page</p>
      <ul className="space-y-1.5 text-sm">
        {sections.map((s) => (
          <li key={s.id}>
            <a href={`#${s.id}`} className="text-blue-600 hover:underline">
              {s.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
